import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { ChatFileModel } from '@models/chat-file.model'
import { notification } from 'onsenui'
import { Subscription } from 'rxjs'

@Component({
    selector: 'app-chat-file',
    templateUrl: './chat-file.component.html',
    styleUrls: ['./chat-file.component.css'],
})
export class ChatFileComponent implements OnInit, OnDestroy {

    @Input() fileModel: ChatFileModel
    @Input() withLoading = true
    @Input() forMobile = false

    public type: string
    public loading = false

    private subscriptions: Subscription[] = []


    constructor() {
    }

    ngOnInit() {
        if (this.fileModel.handlingUpload) {
            this.handlingInput()
        }
        switch (this.fileModel.type) {
            case 'application/pdf':
                this.type = 'pdf'
                break
            default:
                this.type = this.fileModel.type.split('/')[0]
                break
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe())
    }

    private handlingInput() {
        if (this.withLoading) {
            this.loading = true
        }
        this.subscriptions.push(
            this.fileModel.handlingUpload.subscribe((success) => {
                this.loading = false
            }, error => {
                console.error(error)
                if (error.status === 413) {
                } else {
                    this.showError(error.statusText)
                }
            }),
        )
    }

    private showError(message) {
        notification.confirm({
            message: message,
            title: '<b>Alert</b>',
            cancelable: false,
            buttonLabels: ['OK'],
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/commons/chat/chat-file/chat-file.component.ts